// extracted by mini-css-extract-plugin
export default {"name":"DeleteConfirmModal_name__FiTh7","block":"DeleteConfirmModal_block__-vEVH","item":"DeleteConfirmModal_item__xHnf8","strong":"DeleteConfirmModal_strong__MR+HH"};